/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Layout_LineInputs */

const cs_pipelines_layout_line = /** @type {(inputs: Pipelines_Layout_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden řádek`)
};

const en_pipelines_layout_line = /** @type {(inputs: Pipelines_Layout_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single row`)
};

/**
* | output |
* | --- |
* | "Single row" |
*
* @param {Pipelines_Layout_LineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_layout_line = /** @type {((inputs?: Pipelines_Layout_LineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Layout_LineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_layout_line(inputs)
	return cs_pipelines_layout_line(inputs)
});